<template>
  <div>
    <span class="text-h1"> LICENSE RENTAL AGREEMENT </span>
    <p class="text-h5 mt-5">WHEREBY IT IS AGREED AS FOLLOWS:</p>

    <ol id="l1">
      <li>
        <p class="text-h3" style="text-align: left">
          <a name="bookmark0">&zwnj;</a>INTERPRETATION AND PRELIMINARY
        </p>
        <ol id="l2">
          <li data-list-text="1.1.">
            <p
              style="
                padding-top: 5pt;
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 194%;
                text-align: justify;
              "
            >
              The headings of the clauses in this agreement are for the purpose
              of convenience and reference only and shall not be used in the
              interpretation of nor modify nor amplify the terms of this
              agreement nor any clause hereof. Unless a contrary intention
              clearly appears –
            </p>
            <p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
            <ol id="l3">
              <li data-list-text="1.1.1.">
                <p
                  class="s1"
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    text-align: left;
                  "
                >
                  “Affiliates”
                  <span class="p"
                    >– any company affiliated with or forming part of the
                    Licensee.</span
                  >
                </p>
                <p style="text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
              <li data-list-text="1.1.2.">
                <p
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    text-align: left;
                  "
                >
                  &quot;<b>Commencement Date” </b>– the date upon which the
                  license rental period begins to run;
                </p>
                <p style="text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
              <li data-list-text="1.1.3.">
                <p
                  class="s1"
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    line-height: 194%;
                    text-align: justify;
                  "
                >
                  “Confidential Information”
                  <span class="p"
                    >– any and all information about hardware, software,
                    specifications, designs, plans, drawings, data, prototypes,
                    discoveries, research, developments, methods, processes,
                    procedures, improvements, Know How, compilations, market
                    research, marketing techniques and plans, business plans and
                    strategies, customer names and other information related to
                    customers, price information and materials, in oral,
                    demonstrative, written, graphic or machine-readable form,
                    which is unpublished, not available to the general public or
                    trade relating to the Intellectual Property and which is
                    maintained as confidential and proprietary information of
                    the Licensor for regulatory, customer relations, and/or
                    competitive reasons, as well as all information and data
                    belonging to the Licensee which is used and accessed by the
                    Licensor pursuant to the terms of this agreement;</span
                  >
                </p>
                <p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
              <li data-list-text="1.1.4.">
                <p
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    line-height: 193%;
                    text-align: justify;
                  "
                >
                  “<b>Documentation</b>” – any documents provided to the
                  Licensee by the Licensor to be utilized in order to operate or
                  navigate the System.
                </p>
                <p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
              <li data-list-text="1.1.5.">
                <p
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    line-height: 194%;
                    text-align: justify;
                  "
                >
                  &quot;<b>Intellectual Property</b>&quot; – means the
                  Confidential Information and that copyright, trademark, trade
                  name, design, patent (in particular the Patent), software code
                  and trademark of whatsoever nature used in connection with the
                  System or any derivative service offerings thereof necessary
                  to enable the System to be used;
                </p>
                <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
              <li data-list-text="1.1.6.">
                <p
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    line-height: 196%;
                    text-align: justify;
                  "
                >
                  &quot;<b>Know How</b>&quot; – means all the ideas, designs,
                  documents, diagrams, information, devices, technical and
                  scientific data, know how, secret and other processes and
                  methods of the Licensor used in connection with the System;
                </p>
                <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
              <li data-list-text="1.1.7.">
                <p
                  class="s1"
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    line-height: 194%;
                    text-align: justify;
                  "
                >
                  “Licensor”
                  <span class="p"
                    >– ZERO EIGHT FIREARM COMPLIANCE (PTY) LTD Registration
                    Number: 2019/292901/07, a company duly registered and
                    incorporated in accordance with the company laws of the
                    Republic of South Africa and the owner of the Intellectual
                    Property;</span
                  >
                </p>
                <p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
              <li data-list-text="1.1.8.">
                <p
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    line-height: 193%;
                    text-align: justify;
                  "
                >
                  “<b>Licensee” </b>– As stipulated during Licensee registration
                  and on the Licensee’s Profile on “the System” is a company
                  duly registered and incorporated in accordance with the
                  company laws of the Republic of South Africa;
                </p>
                <p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
              <li data-list-text="1.1.9.">
                <p
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    line-height: 194%;
                    text-align: justify;
                  "
                >
                  “<b>Officer/s and Administrative User/s</b>” – The staff
                  members of the Licensee who will become registered “users” of
                  the system. Payment for use of the system shall be tied to the
                  number of Officers and/or Administrative Users registered by
                  the Licensee.
                </p>
                <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
              <li data-list-text="1.1.10.">
                <p
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    line-height: 196%;
                    text-align: justify;
                  "
                >
                  “<b>Patent</b>” – means any patent granted to the Licensor in
                  the Patent Office of the Republic of South Africa any further
                  patents which are granted or recognised anywhere else in the
                  world;
                </p>
                <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
              <li data-list-text="1.1.11.">
                <p
                  class="s1"
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    text-align: left;
                  "
                >
                  “Software Package”
                  <span class="p"
                    >– The Software Package known as “Zero Eight Firearm
                    Compliance”..</span
                  >
                </p>
              </li>
              <li data-list-text="1.1.12.">
                <p
                  style="
                    padding-top: 3pt;
                    padding-left: 50pt;
                    text-indent: -13pt;
                    line-height: 194%;
                    text-align: justify;
                  "
                >
                  &quot;<b>System</b>&quot; – The Software Package in respect of
                  which this license is granted and which the Licensee may
                  utilize, and operate in terms hereof, being the Intellectual
                  Property, Confidential Information, Know How in relation to
                  the software, any Patents in respect thereof as well as the
                  Patent/s itself/themselves.
                </p>
                <p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
              <li data-list-text="1.1.13.">
                <p
                  class="s1"
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    text-align: left;
                  "
                >
                  “Territory”
                  <span class="p">– the Republic of South Africa.</span>
                </p>
                <p style="text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
              <li data-list-text="1.1.14.">
                <p
                  class="s1"
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    line-height: 196%;
                    text-align: justify;
                  "
                >
                  “This Agreement”
                  <span class="p"
                    >– this agreement together with all of its schedules and
                    annexures, which schedules and annexures shall be deemed to
                    be incorporated herein and form a part hereof;</span
                  >
                </p>
                <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
              <li data-list-text="1.1.15.">
                <p
                  class="s1"
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    line-height: 196%;
                    text-align: justify;
                  "
                >
                  &quot;Trademark&quot;
                  <span class="p"
                    >– the trademark “Zero Eight&quot; and its logo and any
                    other trademarks of the Licensor that the Licensee may from
                    time to time agree are to be covered by this
                    Agreement;</span
                  >
                </p>
                <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
              <li data-list-text="1.1.16.">
                <p
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    text-align: left;
                  "
                >
                  &quot;<b>Transfer</b>&quot; – means a sale, license, lease or
                  other form of distribution or transfer.
                </p>
                <p style="text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
            </ol>
          </li>
          <li data-list-text="1.2.">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 193%;
                text-align: justify;
              "
            >
              any reference to an enactment is to that enactment as at the date
              of signature hereof and as amended or re-enacted from time to time
              ;
            </p>
            <p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="1.3.">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 193%;
                text-align: justify;
              "
            >
              if any provision in a definition is a substantive provision
              conferring rights or imposing obligations on any party,
              notwithstanding that it is only in the definition clause, effect
              shall be given to it as if it were a substantive provision in the
              body of the agreement;
            </p>
            <p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="1.4.">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 194%;
                text-align: justify;
              "
            >
              when any number of days is prescribed in this agreement, same
              shall be reckoned exclusively of the first and inclusively of the
              last day unless the last day falls on a Saturday, Sunday or public
              holiday, in which case the last day shall be the next succeeding
              day which is not a Saturday, Sunday or public holiday;
            </p>
            <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="1.5.">
            <p style="padding-left: 25pt; text-indent: -5pt; text-align: left">
              where figures are referred to in numerals and in words, if there
              is any conflict between the two, the words shall prevail;
            </p>
            <p style="text-indent: 0pt; text-align: left"><br /></p>
          </li>
          <li data-list-text="1.6.">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 193%;
                text-align: justify;
              "
            >
              expressions defined in this agreement shall bear the same meanings
              in schedules or annexures to this agreement which do not
              themselves contain their own conflicting definitions;
            </p>
            <p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="1.7.">
            <p style="padding-left: 25pt; text-indent: -5pt; text-align: left">
              reference to day/s, month/s or year/s shall be construed as
              Gregorian calendar day/s, month/s or year/s;
            </p>
            <p style="text-indent: 0pt; text-align: left"><br /></p>
          </li>
          <li data-list-text="1.8.">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 194%;
                text-align: justify;
              "
            >
              where any term is defined within the context of any particular
              clause in this agreement, the term so defined, unless it is clear
              from the clause in question that the term so defined has limited
              application to the relevant clause, shall bear the meaning
              ascribed to it for all purposes in terms of this agreement,
              notwithstanding that that term has not been defined in this
              interpretation claus e;
            </p>
            <p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="1.9.">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 194%;
                text-align: justify;
              "
            >
              the expiration or termination of this agreement shall not affect
              such of the provisions of this agreement as expressly provide that
              they will operate after any such expiration or termination or
              which of necessity must continue to have effect after such
              expiration or termination, notwithstanding that the clauses
              themselves do not expressly provide for this;
            </p>
            <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="1.10.">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 196%;
                text-align: justify;
              "
            >
              the rule of construction that a contract shall be interpreted
              against the party responsible for the drafting or preparation of
              the contract, shall not apply;
            </p>
            <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="1.11.">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 194%;
                text-align: justify;
              "
            >
              any reference in this agreement to a party shall include a
              reference to that party’s assigns expressly permitted under this
              agreement and, if such party is liquidated or sequestrated, be
              applicable also to and binding upon that party’s liquidator or
              trustee, as the case may be;
            </p>
            <p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="1.12.">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 193%;
                text-align: justify;
              "
            >
              the words “include”, “including” and “in particular” shall be
              construed as being by way of example or emphasis only and shall
              not be construed as, nor shall they take effect as, limiting the
              generality of any preceding word/s;
            </p>
          </li>
          <li data-list-text="1.13.">
            <p
              style="
                padding-top: 3pt;
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 196%;
                text-align: justify;
              "
            >
              the words “other” and “otherwise” shall not be construed
              <i>eiusdem generis </i>with any preceding words where a wider
              construction is possible.
            </p>
            <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="1.14.">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 194%;
                text-align: justify;
              "
            >
              if any provision in a schedule to this agreement is a substantive
              provision conferring rights or imposing obligations on any party,
              notwithstanding that it is only in a schedule to this agreement,
              effect shall be given to it as if it were a substantive pro vision
              in the body of the agreement
            </p>
            <p style="padding-top: 9pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text="2.">
        <p class="text-h3" style="text-align: left">
          <a name="bookmark1">&zwnj;</a>INTRODUCTION
        </p>
        <ol id="l4">
          <ol id="l5">
            <li data-list-text="2.1">
              <p
                style="
                  padding-top: 5pt;
                  padding-left: 25pt;
                  text-indent: -5pt;
                  text-align: left;
                "
              >
                The Licensor is the holder of the Intellectual Property.
              </p>
              <p style="text-indent: 0pt; text-align: left">
                <br />
              </p>
            </li>
            <li data-list-text="2.2">
              <p
                style="padding-left: 25pt; text-indent: -5pt; text-align: left"
              >
                The Licensee requires the license and right herein envisaged for
                the purposes of utilising the System;
              </p>
              <p style="text-indent: 0pt; text-align: left">
                <br />
              </p>
            </li>
            <li data-list-text="2.3">
              <p
                style="
                  padding-left: 25pt;
                  text-indent: -5pt;
                  line-height: 194%;
                  text-align: justify;
                "
              >
                The Licensor has accordingly agreed to rent the Licensee the
                license herein envisaged in order to enable it to utilise the
                System for its own business purposes and in the ordinary course
                of its business and the Licensee has agreed to accept the rental
                thereof, on the terms and conditions herein contained.
              </p>
            </li>
          </ol>
        </ol>
        <p style="padding-top: 8pt; text-indent: 0pt; text-align: left">
          <br />
        </p>
      </li>
      <li data-list-text="3.">
        <p class="text-h3" style="text-align: left">
          <a name="bookmark2">&zwnj;</a>RENTAL OF LICENSE AND LICENSE RENTAL FEE
        </p>
        <ol id="l6">
          <li data-list-text="3.1.">
            <p
              style="
                padding-top: 5pt;
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 194%;
                text-align: justify;
              "
            >
              In respect of System/s as the parties may agree upon from time to
              time in writing and subject always to the terms of this agreement,
              the Licensor Allows the Licensee a license to use the System, the
              Documentation, the Intellectual Property and Know How for its own
              business purposes and during the ordinary course of its business
              subject to 3.3 below.
            </p>
            <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="3.2.">
            <p style="padding-left: 25pt; text-indent: -5pt; text-align: left">
              The license hereby let to the Licensee applies solely to the
              System.
            </p>
            <p style="text-indent: 0pt; text-align: left"><br /></p>
          </li>
          <li data-list-text="3.3.">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 194%;
                text-align: justify;
              "
            >
              The rental license fee in respect of the system shall be as
              specified during the sign-up process on PayFast. The Licensee
              agrees to pay this fee promptly according to the payment terms
              specified on PayFast. Any changes to the rental license fee shall
              be communicated by the Licensor to the Licensee in writing or
              through electronic communication or on PayFast during an upgrade,
              with reasonable notice provided.
            </p>
            <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="3.4.">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 194%;
                text-align: justify;
              "
            >
              The Licensee agrees to pay the Licensor all software license fees
              as specified in the relevant purchase order or agreement. All
              payments for software license fees shall be processed through
              PayFast, an online payment gateway. The Licensee shall provide all
              necessary payment information and authorizations required by
              PayFast to facilitate the payment. The Licensor shall not be
              liable for any delays or failures in payment processing
              attributable to PayFast. The Licensee is responsible for any
              transaction fees or charges associated with the payment processing
              through PayFast.
            </p>
            <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="3.5.">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 194%;
                text-align: justify;
              "
            >
              It is further specifically agreed that if the Licensee is required
              to pay a “once-off” initiation fee to the Licensor within 7 days
              of signature hereof, it being understood that this “once-off” fee
              shall constitute part of the first month’s Licence Rental Fee and
              shall not be recoverable by the Licensee from the Licensor in the
              event of early termination hereof in terms of 5.1 below.
            </p>
            <p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="3.6.">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 194%;
                text-align: justify;
              "
            >
              The License Rental Fee referred to above covers training, any
              basic necessary upgrades, updates, fixes and patches to the
              System, it being understood and agreed that the installation or
              development of additional software and maintenance services over
              and above general maintenance and necessary updates in this
              respect shall be governed by a separate Service Level Agreement.
              For the avoidance of doubt, it is specifically agreed that a
              separate service fee will be charged for the service of
              installation or development and maintenance of value-added
              upgrades, updates, fixes and patches to the System in accordance
              with the said Service Level Agreement.
            </p>
          </li>
          <li data-list-text="3.7.">
            <p
              style="
                padding-top: 3pt;
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 196%;
                text-align: justify;
              "
            >
              It is specifically agreed and understood that loading new Officers
              shall not be charged to the Licensee up to the maximum Officer
              limit in respect of a specific package, but once the Officer limit
              is reached a new package shall have to be upgraded to a new limit.
            </p>
            <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="3.8.">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 194%;
                text-align: justify;
              "
            >
              The Licensor shall provide training to the Licensee’s
              representatives, up to a maximum of 6 (six) participants per
              license. In the event that the Licensee requires further parties
              to be trained, such training will be quoted and charged separately
              in accordance with the Licensor’s prevailing rate for such a
              service.
            </p>
            <p style="padding-top: 9pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text="4.">
        <p class="text-h3" style="text-align: left">
          <a name="bookmark3">&zwnj;</a>RESTRICTIONS OF USE OF THE SYSTEM
        </p>
        <ol id="l7">
          <li data-list-text="4.1.">
            <p
              style="
                padding-top: 5pt;
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 193%;
                text-align: justify;
              "
            >
              The Licensor pursuant to this Agreement, subject to clause 6
              hereof, and subject to the other conditions and restrictions set
              forth herein, hereby lets to the Licensee, a non- transferable
              License throughout the Territory to:
            </p>
            <p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="4.2.">
            <p style="padding-left: 25pt; text-indent: -5pt; text-align: left">
              Use the System, in accordance with the documentation.
            </p>
            <p style="text-indent: 0pt; text-align: left"><br /></p>
          </li>
          <li data-list-text="4.3.">
            <p style="padding-left: 25pt; text-indent: -5pt; text-align: left">
              The Licensee, shall not, without the prior written consent of the
              Licensor:
            </p>
            <p style="padding-top: 8pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
            <ol id="l8">
              <li data-list-text="4.3.1.">
                <p
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    text-align: left;
                  "
                >
                  In any way sell, alienate or dispose of all or any part of the
                  System, or the documentation;
                </p>
                <p style="padding-top: 8pt; text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
              <li data-list-text="4.3.2.">
                <p
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    text-align: left;
                  "
                >
                  In any way use the System save and except for the express
                  purpose as set out in paragraph 3.1 above;
                </p>
                <p style="padding-top: 5pt; text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
              <li data-list-text="4.3.3.">
                <p
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    line-height: 147%;
                    text-align: left;
                  "
                >
                  In any way attempt to modify, decompile, disassemble, reverse
                  engineer, or derive the source codes or algorithms of the
                  Software Package.
                </p>
                <p style="padding-top: 1pt; text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
            </ol>
          </li>
          <li data-list-text="4.4.">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 146%;
                text-align: justify;
              "
            >
              The Licensee agrees that the software provided by the Licensor is
              confidential and proprietary. The Licensee agrees not to disclose,
              transfer, or provide access to the Software, in whole or in part,
              to any third party, including but not limited to other software
              companies, without the prior written consent of The Licensor.
            </p>
            <p style="text-indent: 0pt; text-align: left"><br /></p>
          </li>
          <li data-list-text="4.5.">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 146%;
                text-align: justify;
              "
            >
              The Licensee acknowledges that unauthorised disclosure or use of
              the Software may cause irreparable harm to The Licensor, for which
              monetary damages may be difficult to ascertain or inadequate as a
              remedy. Therefore, The Licensor shall be entitled to seek
              injunctive relief in addition to any other remedies available at
              law or in equity. This obligation of confidentiality and non-
              disclosure shall survive the termination of any agreement between
              the parties.
            </p>
            <p style="text-indent: 0pt; text-align: left"><br /></p>
          </li>
        </ol>
      </li>
      <li data-list-text="5.">
        <p class="text-h3" style="text-align: left">
          <a name="bookmark4">&zwnj;</a>DURATION
        </p>
        <ol id="l9">
          <ol id="l10">
            <li data-list-text="5.1">
              <p
                style="
                  padding-top: 5pt;
                  padding-left: 25pt;
                  text-indent: -5pt;
                  line-height: 194%;
                  text-align: justify;
                "
              >
                This agreement shall commence on the first day of the month
                after which this agreement is signed and shall endure for 1
                calendar year (“the initial term”), subject to 5.2 below and
                provided any of the parties may terminate this agreement by
                giving the other 90 (ninety) days’ notice of such termination,
                subject to 5.1.1 below.
              </p>
              <p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
                <br />
              </p>
              <ol id="l11">
                <li data-list-text="5.1.1">
                  <p
                    style="
                      padding-left: 50pt;
                      text-indent: -13pt;
                      line-height: 194%;
                      text-align: justify;
                    "
                  >
                    Should either party terminate this agreement before the end
                    of any of its terms for any reason whatsoever, the Licensee
                    shall have the option to purchase a perpetual licence for
                    the version of the System as it stands at the date of such
                    termination for a consideration equivalent to 10 years’
                    license rental fees calculated at the rate prevailing at the
                    time of termination.
                  </p>
                  <p
                    style="padding-top: 2pt; text-indent: 0pt; text-align: left"
                  >
                    <br />
                  </p>
                </li>
                <li data-list-text="5.1.2">
                  <p
                    style="
                      padding-left: 50pt;
                      text-indent: -13pt;
                      line-height: 194%;
                      text-align: justify;
                    "
                  >
                    It is specifically agreed that in the event that the number
                    of users or officers of the software exceeds the initially
                    agreed upon limit, Licensee agrees to promptly notify
                    Licensor and pay an additional licensing fee commensurate
                    with the increased user count, as per the terms agreed upon
                    in the initial licensing agreement, subject to 5.1.1 above.
                  </p>
                  <p
                    style="padding-top: 2pt; text-indent: 0pt; text-align: left"
                  >
                    <br />
                  </p>
                </li>
              </ol>
            </li>
            <li data-list-text="5.2">
              <p
                style="
                  padding-left: 25pt;
                  text-indent: -5pt;
                  line-height: 196%;
                  text-align: justify;
                "
              >
                It is specifically agreed that this agreement may be renewed for
                a further year (“the renewal period”) at the instance of the
                Licensee subject to what is contained in 5.2.1 and 5.2.2 below.
              </p>
              <ol id="l12">
                <li data-list-text="5.2.1">
                  <p
                    style="
                      padding-top: 3pt;
                      padding-left: 50pt;
                      text-indent: -13pt;
                      line-height: 196%;
                      text-align: left;
                    "
                  >
                    The Licensee is to indicate its intention to exercise the
                    aforesaid right of renewal in writing no less than 2 months
                    prior to the expiry of the initial term;
                  </p>
                  <p
                    style="padding-top: 2pt; text-indent: 0pt; text-align: left"
                  >
                    <br />
                  </p>
                </li>
                <li data-list-text="5.2.2">
                  <p
                    style="
                      padding-left: 50pt;
                      text-indent: -13pt;
                      line-height: 196%;
                      text-align: left;
                    "
                  >
                    The fees payable for the renewal period will escalate in
                    accordance with the consumer price index or at a rate of 10%
                    (ten per centum) (whichever is the higher).
                  </p>
                  <p
                    style="padding-top: 2pt; text-indent: 0pt; text-align: left"
                  >
                    <br />
                  </p>
                </li>
              </ol>
            </li>
            <li data-list-text="5.3">
              <p
                style="
                  padding-left: 25pt;
                  text-indent: -5pt;
                  line-height: 194%;
                  text-align: justify;
                "
              >
                It is specifically agreed that this agreement may be renewed
                annually after the initial renewal period as many times as the
                parties desire in accordance with the mechanism contained in
                clause 5.1 above and that the provisions of this agreement will
                continue to apply <i>mutatis mutandis </i>for each successive
                renewal period.
              </p>
              <p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
                <br />
              </p>
            </li>
            <li data-list-text="5.4">
              <p
                style="
                  padding-left: 25pt;
                  text-indent: -5pt;
                  line-height: 194%;
                  text-align: justify;
                "
              >
                Upon termination any and all rights afforded the parties in
                terms hereof shall cease to be of any further force or effect
                sav e that the grant of any license shall endure for the balance
                of the period paid for and save for the fact that the
                obligations imposed on the Licensee regarding the supply of Know
                How by the Licensor, Intellectual Property, Trademarks, Patents
                and Secrecy shall survive the termination of this Agreement.
              </p>
              <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
                <br />
              </p>
            </li>
            <li data-list-text="5.5">
              <p
                style="
                  padding-left: 25pt;
                  text-indent: -5pt;
                  line-height: 194%;
                  text-align: justify;
                "
              >
                For the avoidance of doubt it is specifically agreed that should
                the Licensee wish to cancel this Agreement within a year for
                which they have paid the Licence Rental Fee annually in advance,
                the Licensee shall not be entitled to any pro-rated refund in
                respect thereof. It is agreed that the obligations of the
                Licensor shall only endure for the period covered by that which
                has been paid for.
              </p>
            </li>
          </ol>
        </ol>
        <p style="padding-top: 8pt; text-indent: 0pt; text-align: left">
          <br />
        </p>
      </li>
      <li data-list-text="6.">
        <p class="text-h3" style="text-align: left">
          <a name="bookmark5">&zwnj;</a>SUB-LICENSE AND LICENSE IN RESPECT OF
          AFFILIATES
        </p>
        <p
          style="
            padding-top: 5pt;
            padding-left: 25pt;
            text-indent: -13pt;
            text-align: left;
          "
        >
          6.1 The Licensee shall not be entitled to grant sub-licenses to its
          affiliates.
        </p>
        <p style="text-indent: 0pt; text-align: left"><br /></p>
      </li>
      <li data-list-text="7.">
        <p class="text-h3" style="text-align: left">
          <a name="bookmark6">&zwnj;</a>SUPPLY OF KNOW HOW
        </p>
        <ol id="l13">
          <li data-list-text="7.1.">
            <p
              style="
                padding-top: 5pt;
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 194%;
                text-align: justify;
              "
            >
              The Licensor shall make available to the Licensee all necessary
              Know How during the period of this agreement and the parties shall
              co-operate with each other to ensure that the Licensee is able to
              utilise the System in accordance with the terms of this Agreement.
            </p>
            <p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="7.2.">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 193%;
                text-align: justify;
              "
            >
              As set out in 3.6 above, the Licensor shall provide initial
              training on the utilization of the system, and shall, should it
              become necessary, provide further training on an ad hoc basis, at
              its prevailing rate.
            </p>
            <p style="padding-top: 9pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text="8.">
        <p class="text-h3" style="text-align: left">
          <a name="bookmark7">&zwnj;</a>THE INTELLECTUAL PROPERTY
        </p>
        <ol id="l14">
          <li data-list-text="8.1.">
            <p
              style="
                padding-top: 5pt;
                padding-left: 25pt;
                text-indent: -5pt;
                text-align: left;
              "
            >
              The Licensee acknowledges that –
            </p>
            <p style="text-indent: 0pt; text-align: left"><br /></p>
            <ol id="l15">
              <li data-list-text="8.1.1.">
                <p
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    line-height: 194%;
                    text-align: justify;
                  "
                >
                  the Intellectual Property and the goodwill associated
                  therewith are the sole and exclusive property of the Licensor
                  and agree that any use thereof shall as between the Licensee
                  and the Licensor inure for the benefit of the Licensor to the
                  exclusion of the Licensee. The Licensee shall not in any
                  manner represent that it has any rights of ownership in the
                  Intellectual Property.
                </p>
                <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
            </ol>
          </li>
          <li data-list-text="8.2.">
            <p style="padding-left: 25pt; text-indent: -5pt; text-align: left">
              The Licensee shall -
            </p>
            <p style="text-indent: 0pt; text-align: left"><br /></p>
            <ol id="l16">
              <li data-list-text="8.2.1.">
                <p
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    text-align: left;
                  "
                >
                  comply with all laws relating to the Intellectual Property in
                  the Territory;
                </p>
                <p style="text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
              <li data-list-text="8.2.2.">
                <p
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    text-align: left;
                  "
                >
                  not use the Intellectual Property in any manner which could or
                  would be likely to deceive or confuse the public;
                </p>
                <p style="text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
            </ol>
          </li>
          <li data-list-text="8.3.">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 196%;
                text-align: justify;
              "
            >
              In the course of this agreement and the free flow of information
              between the parties, the Licensor may make disclosures to the
              Licensee which could prejudice the Licensor in regard to the
              Intellectual Property. The Licensee shall accordingly not use any
            </p>
            <p
              style="
                padding-top: 3pt;
                padding-left: 25pt;
                text-indent: 0pt;
                line-height: 196%;
                text-align: left;
              "
            >
              such disclosures to prejudice the Licensor during the agreement or
              thereafter and shall not oppose any application for the extension
              of the registration of any of the Intellectual Property during
              this agreement or at any time thereafter.
            </p>
            <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="8.4.">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 195%;
                text-align: justify;
              "
            >
              In the course of this agreement and the free flow of information
              between the parties, the Licensee may make disclosures to the
              Licensor which could prejudice the Licensee in regard to its
              Intellectual Property. The Licensor shall accordingly not use any
              such disclosures to prejudice the Licensee during the agreement or
              thereafter and shall not oppose any application for the extension
              of the registration of any of the Licensee’s Intellectual Property
              during this agreement or at any time thereafter.
            </p>
            <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="8.5.">
            <p style="padding-left: 25pt; text-indent: -5pt; text-align: left">
              The Licensor warrants that -
            </p>
            <p style="text-indent: 0pt; text-align: left"><br /></p>
            <ol id="l17">
              <li data-list-text="8.5.1.">
                <p
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    text-align: left;
                  "
                >
                  its rights in and to the Intellectual Property are valid;
                </p>
                <p style="text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
              <li data-list-text="8.5.2.">
                <p
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    line-height: 196%;
                    text-align: left;
                  "
                >
                  no person will be entitled to an order for the expungement of
                  that part of the Intellectual Property which is registered in
                  the Territory;
                </p>
                <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
              <li data-list-text="8.5.3.">
                <p
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    line-height: 196%;
                    text-align: left;
                  "
                >
                  the exploitation of the Intellectual Property or Know How in
                  the Territory will not constitute an infringement of the
                  rights of any other person.
                </p>
                <p style="padding-top: 8pt; text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <li data-list-text="9.">
        <p class="text-h3" style="text-align: left">
          <a name="bookmark8">&zwnj;</a>INFRINGEMENT AND APPLICATIONS FOR
          REVOCATION
        </p>
        <ol id="l18">
          <li data-list-text="9.1.">
            <p
              style="
                padding-top: 5pt;
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 195%;
                text-align: justify;
              "
            >
              If during the terms of this agreement any infringement or illegal
              use of any aspect of the Intellectual Property should come to the
              attention of either of the parties, or should an attachment be
              made, or threatened against the validity or enforceability of a
              patent then and in such event that party shall notify the other
              party of such infringement, illegal use or attack and provide the
              other party with any and all relevant documents in connection
              therewith;
            </p>
            <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="9.2.">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 196%;
                text-align: justify;
              "
            >
              The Licensor, in its discretion, shall then decide on the legal
              action to be taken. The cost of any such action shall be for the
              Licensor’s account;
            </p>
            <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="9.3.">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 195%;
                text-align: justify;
              "
            >
              The Licensor agrees that if the Licensee in the exercise of its
              rights under this agreement is sued by any third party on the
              grounds that the Intellectual Property constitutes an infringement
              of such third party’s patent or other intellectual property
              rights, the Licensor shall provide the Licensee with assistance to
              the best of its ability to enable the Licensee to defend any legal
              application or action brought against the Licensee;
            </p>
            <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="9.4.">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 194%;
                text-align: justify;
              "
            >
              The Licensor further agrees that it will be responsible for and
              bear the reasonable costs of any litigation incurred by the
              Licensee or damages awarded against the Licensee or consequential
              loss occurred by the Licensee as a result of any litigation
              envisage d in clause 9.3.
            </p>
            <p style="padding-top: 9pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text="10.">
        <p class="text-h3" style="text-align: left">
          <a name="bookmark9">&zwnj;</a>SECRECY AND DATA PROTECTION
        </p>
        <p
          style="
            padding-top: 5pt;
            padding-left: 20pt;
            text-indent: 0pt;
            line-height: 196%;
            text-align: left;
          "
        >
          Both parties acknowledge that the Intellectual Property which they
          will obtain pursuant to the provisions of this agreement, including in
          particular the Confidential Information constitute trade secrets of
          the respective parties. Accordingly, each of the parties undertake -
        </p>
        <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
          <br />
        </p>
        <ol id="l19">
          <li data-list-text="10.1.">
            <p style="padding-left: 25pt; text-indent: -5pt; text-align: left">
              to treat as confidential such information during and after the
              expiry of this license;
            </p>
            <p style="text-indent: 0pt; text-align: left"><br /></p>
          </li>
          <li data-list-text="10.2.">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 193%;
                text-align: justify;
              "
            >
              to use the confidential information only for the purposes of and
              to the extent required to perform its obligations and exercise its
              rights in terms of this licence;
            </p>
            <p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="10.3.">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 193%;
                text-align: justify;
              "
            >
              not to divulge such confidential information to any third party
              except to those of its employees and selling agents who have a
              specific need to know such information in connection with this
              license. Before revealing such information to their respective
            </p>
          </li>
        </ol>
      </li>
    </ol>
    <p
      style="
        padding-top: 3pt;
        padding-left: 25pt;
        text-indent: 0pt;
        line-height: 195%;
        text-align: justify;
      "
    >
      employees and selling agents the parties shall be obliged to obtain from
      any such employees and selling agents a secrecy agreement in such form as
      the other party requires from time to time. Each of the parties undertakes
      to ensure that its emplo yees and selling agents will observe and comply
      with their obligations in terms hereof whether or not they are still
      employees and/or selling agents of the concerned party;
    </p>
    <p style="padding-top: 8pt; text-indent: 0pt; text-align: left">
      <br />
    </p>
    <ol id="l20">
      <ol id="l21">
        <li data-list-text="10.4">
          <p
            style="
              padding-left: 25pt;
              text-indent: -5pt;
              line-height: 106%;
              text-align: left;
            "
          >
            <a name="bookmark10">&zwnj;</a>not to use such information directly
            or indirectly for its benefit or the benefit of any third party,
            except for the purposes of this license.
          </p>
          <p style="text-indent: 0pt; text-align: left"><br /></p>
        </li>
        <li data-list-text="10.5">
          <p
            style="
              padding-left: 25pt;
              text-indent: -5pt;
              line-height: 111%;
              text-align: left;
            "
          >
            <a name="bookmark11">&zwnj;</a>The Licensee shall be responsible for
            the input of its data into the System, which shall be necessary for
            the use of the system by the Licensee and its relevant Users and
            Officers.
          </p>
          <p style="padding-top: 9pt; text-indent: 0pt; text-align: left">
            <br />
          </p>
        </li>
        <li data-list-text="10.6">
          <p
            style="
              padding-left: 25pt;
              text-indent: -5pt;
              line-height: 112%;
              text-align: left;
            "
          >
            <a name="bookmark12">&zwnj;</a>The Licensee acknowledges that the
            Licensor and its agents and/or employees shall have access to the
            Licensee’s data and consents to such access being granted.
          </p>
          <p style="padding-top: 8pt; text-indent: 0pt; text-align: left">
            <br />
          </p>
        </li>
        <li data-list-text="10.7">
          <p
            style="
              padding-left: 25pt;
              text-indent: -5pt;
              line-height: 111%;
              text-align: left;
            "
          >
            <a name="bookmark13">&zwnj;</a>The Licensor declares that any
            processing of personal information and data is in compliance with
            The Protection of Personal Information Act no 4 of 2013.
          </p>
          <p style="padding-top: 8pt; text-indent: 0pt; text-align: left">
            <br />
          </p>
        </li>
        <li data-list-text="10.8">
          <p
            style="
              padding-left: 25pt;
              text-indent: -5pt;
              line-height: 112%;
              text-align: left;
            "
          >
            <a name="bookmark14">&zwnj;</a>The Licensee expressly consents to
            the processing of any relevant confidential or personal information
            and/or special personal information by way of the trans-border flow
            of information. This will occur where personal information has to be
            sent to service providers outside of the Republic of South Africa
            for processing and/or storage, and/or is necessary for the
            performance in terms of the contractual relationship. The Licensee
            understands that the information sent to another country might not
            be subject to the same legislation as it might not have similar
            information protection legislation in place.
          </p>
          <p style="padding-top: 8pt; text-indent: 0pt; text-align: left">
            <br />
          </p>
        </li>
        <li data-list-text="10.9">
          <p
            style="
              padding-left: 25pt;
              text-indent: -5pt;
              line-height: 112%;
              text-align: left;
            "
          >
            <a name="bookmark15">&zwnj;</a>The Licensor shall take the necessary
            steps to ensure its compliance with generally accepted information
            security practices, however data transmission on the internet can be
            subject to security gaps. Notwithstanding the technical and
            organisational security measures taken by the Licensor, manipulation
            by third parties or loss of data cannot be completely ruled out. In
            case of any data breach, the Licensor will promptly report to the
            affected person and the relevant authority.
          </p>
        </li>
      </ol>
    </ol>
    <p style="text-indent: 0pt; text-align: left"><br /></p>
    <p
      class="text-h3"
      style="padding-left: 10pt; text-indent: 0pt; text-align: left"
    >
      11. WARRANTIES
    </p>
    <p style="text-indent: 0pt; text-align: left"><br /></p>
    <ol id="l22">
      <ol id="l23">
        <li data-list-text="11.1">
          <p
            style="
              padding-left: 25pt;
              text-indent: -5pt;
              line-height: 111%;
              text-align: left;
            "
          >
            <a name="bookmark16">&zwnj;</a> The Licensor warrants to the
            Licensee that the System shall substantially perform in accordance
            with the documentation and specifically in accordance with the
            contents of Schedule “C”. Should the System not perform in
            accordance therewith the Licensor shall endeavour to ensure that the
            defect is rectified within a commercially reasonable period.
          </p>
          <p style="padding-top: 9pt; text-indent: 0pt; text-align: left">
            <br />
          </p>
        </li>
        <li data-list-text="11.2">
          <p
            style="
              padding-left: 25pt;
              text-indent: -5pt;
              line-height: 112%;
              text-align: left;
            "
          >
            <a name="bookmark17">&zwnj;</a> Errors which may occur as a result
            of the Licensee’s technical environment are not covered under the
            above warranty. It is further specifically agreed that any errors
            which occur as a result of the Licensee’s technical environment are
            not covered under License Rental Fee referred to in 3.3 above and
            shall accordingly be rectified at the cost of the Licensee.
          </p>
          <p style="padding-top: 8pt; text-indent: 0pt; text-align: left">
            <br />
          </p>
        </li>
        <li data-list-text="11.3">
          <p
            style="
              padding-left: 25pt;
              text-indent: -5pt;
              line-height: 112%;
              text-align: left;
            "
          >
            <a name="bookmark18">&zwnj;</a>In the event that the Licensor
            breaches the warranty as set out above, the Licensor’s entire
            liability, and the exclusive remedy available to the Licensee will
            be, at the option of the Licensee, either (i) the System shall
            either be returned to the Licensor (ii) the Licensor shall repair or
            replace the System so that it does comply with the warranty
            provided; or and only if (iii) within a commercially reasonable
            period, the Licensor neither repairs such defects nor replaces the
            defective software, then Licensee&#39;s sole and exclusive remedy
            shall be to claim direct damages not to exceed the License Rental
            Fees paid to Licensor for use of the defective software.<a
              name="bookmark19"
              >&zwnj;</a
            ><a name="bookmark20">&zwnj;</a>
          </p>
          <p style="padding-top: 8pt; text-indent: 0pt; text-align: left">
            <br />
          </p>
        </li>
        <li data-list-text="11.4">
          <p
            style="
              padding-left: 25pt;
              text-indent: -5pt;
              line-height: 113%;
              text-align: left;
            "
          >
            <a name="bookmark21">&zwnj;</a>The warranty provided by the Licensor
            is void if failure of the software has resulted from accident,
            abuse, misapplication, abnormal use, unauthorised amendments, or a
            virus not attributable to the Licensor.
          </p>
        </li>
      </ol>
    </ol>
    <p style="padding-top: 8pt; text-indent: 0pt; text-align: left">
      <br />
    </p>
    <ol id="l24">
      <li data-list-text="12.">
        <p class="text-h3" style="text-align: left">
          <a name="bookmark22">&zwnj;</a>LIMITATION OF LIABILITY AND INDEMNITY
        </p>
        <ol id="l25">
          <li data-list-text="12.1">
            <p style="padding-left: 25pt; text-indent: -5pt; text-align: left">
              Subject to 12.2 below, neither party shall be liable for any:
            </p>
            <p style="text-indent: 0pt; text-align: left"><br /></p>
            <ol id="l26">
              <li data-list-text="12.1.1">
                <p
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    line-height: 193%;
                    text-align: left;
                  "
                >
                  special, indirect, incidental, punitive, or consequential
                  damages, including loss of profits, arising from or related to
                  a breach of this Agreement or the operation or use of the
                  System; or
                </p>
              </li>
              <li data-list-text="12.1.2">
                <p
                  style="
                    padding-top: 3pt;
                    padding-left: 50pt;
                    text-indent: -13pt;
                    line-height: 196%;
                    text-align: justify;
                  "
                >
                  damages (regardless of their nature) for any delay or failure
                  by the other party to perform its obligations under this
                  Agreement due to any cause beyond such party&#39;s reasonable
                  control.
                </p>
                <p style="padding-top: 8pt; text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
            </ol>
          </li>
          <li data-list-text="12.2">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 193%;
                text-align: justify;
              "
            >
              It is specifically agreed that no limitation of liability as
              provided for in this Agreement shall apply in respect of a breach
              related to the Intellectual Property or to any Patents, Trademarks
              or Know How as contemplated herein.
            </p>
            <p style="padding-top: 8pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="12.3">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 195%;
                text-align: justify;
              "
            >
              Notwithstanding any other provision of this Agreement, save for
              clause 12.2 above, either party’s liabilities under this
              Agreement, whether under contract, delict, warranty or otherwise
              shall be limited to direct damages not to exceed the amounts
              actually received by licensor pursuant to the particular order
              from which such damages arose. For the avoidance of doubt, neither
              party&#39;s monetary remedies for any breach of any provision of
              this Agreement, save in respect of 12.2 above (including, without
              limitation, the warranty provisions) shall, in the aggregate,
              exceed an amount equal to the amounts actually received by
              Licensor from Licensee.
            </p>
            <p style="padding-top: 8pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
            <ol id="l27">
              <ol id="l28">
                <li data-list-text="12.5">
                  <p
                    style="
                      padding-left: 25pt;
                      text-indent: -5pt;
                      line-height: 194%;
                      text-align: justify;
                    "
                  >
                    Subject to the limitations contained in this Agreement, the
                    Licensor agrees to indemnify and hold harmless Licensee, and
                    Licensee agrees to indemnify and hold harmless Licensor
                    respectively, from any liabilities, penalties, demands or
                    claims finally awarded (including the costs, expenses and
                    reasonable attorney&#39;s fees on account thereof) that may
                    be made by any third party for personal bodily injuries,
                    including death, resulting from the indemnifying party&#39;s
                    gross negligence or wilful acts or omissions or those of
                    persons furnished by the indemnifying party, its agents or
                    subcontractors or resulting from use of the software.
                  </p>
                  <p
                    style="padding-top: 8pt; text-indent: 0pt; text-align: left"
                  >
                    <br />
                  </p>
                </li>
                <li data-list-text="12.6">
                  <p
                    style="
                      padding-left: 25pt;
                      text-indent: -5pt;
                      line-height: 194%;
                      text-align: justify;
                    "
                  >
                    The Licensee agrees to indemnify, defend, and hold harmless
                    the Licensor, its officers, directors, employees, and agents
                    from and against any and all claims, liabilities, losses,
                    damages, costs, and expenses (including reasonable
                    attorneys&#39; fees) arising out of or related to the arrest
                    or detention of the Licensee or any of its employees or
                    associates, except to the extent caus ed by the gross
                    negligence or wilful misconduct of the Licensor
                  </p>
                  <p
                    style="padding-top: 8pt; text-indent: 0pt; text-align: left"
                  >
                    <br />
                  </p>
                </li>
                <li data-list-text="12.7">
                  <p
                    style="
                      padding-left: 25pt;
                      text-indent: -5pt;
                      line-height: 194%;
                      text-align: justify;
                    "
                  >
                    In the event of any infringement or claim of infringement of
                    any third party patent, trademark, copyright, trade secret
                    or other proprietary interest based on the licensing, use,
                    or sale of the software furnished to Licensee under this
                    Agreement or in contemplation hereof, subject to the
                    limitations contained in this Agreement, Licensor shall hold
                    harmless, defend and indemnify Licensee for any loss,
                    damage, expense or liability, including costs and reasonable
                    attorney&#39;s fees, finally awarded, that may result by
                    reason of any such infringement or claim.
                  </p>
                  <p
                    style="padding-top: 8pt; text-indent: 0pt; text-align: left"
                  >
                    <br />
                  </p>
                </li>
                <li data-list-text="12.8">
                  <p
                    style="
                      padding-left: 25pt;
                      text-indent: -5pt;
                      line-height: 194%;
                      text-align: justify;
                    "
                  >
                    Each party shall defend or settle, at its own expense, any
                    action or suit against the other for which it has
                    indemnification obligations in terms of this Agreement. Each
                    party shall notify the other promptly of any claim of
                    infringement for which the other is responsible and shall
                    cooperate with the other in every reasonable way to
                    facilitate the defence of any such claim.
                  </p>
                </li>
              </ol>
            </ol>
            <p style="padding-top: 9pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text="13.">
        <p class="text-h3" style="text-align: left">
          <a name="bookmark23">&zwnj;</a>BREACH AND CANCELLATION
        </p>
        <ol id="l29">
          <li data-list-text="13.1">
            <p
              style="
                padding-top: 5pt;
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 194%;
                text-align: justify;
              "
            >
              If any party breaches any material provision or term of this
              Agreement (other than those which contain their own remedies or
              limit the remedies in the event of a breach thereof) and fails to
              remedy such breach within 14 (fourteen) days of receipt of written
              notice requiring it to do so, then the aggrieved party shall be
              entitled on 30 days’ notice, in addition to any other remedy
              available to it at law or under this agreement, including
              obtaining an interdict, to cancel this agreement or to claim
              specific performance of any obligation whether or not the due date
              for performance has arrived, in either event without prejudice to
              the aggrieved party&#39;s right to claim damages.
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text="14.">
        <p class="text-h3" style="padding-top: 15pt; text-align: left">
          <a name="bookmark24">&zwnj;</a>CESSATION OF RIGHTS
        </p>
        <p style="padding-top: 5pt; padding-left: 25pt; text-align: left">
          The Licensee agrees that upon termination of this license for any
          cause whatsoever and howsoever arising:
        </p>
        <p style="text-indent: 0pt; text-align: left"><br /></p>
        <ol id="l30">
          <li data-list-text="14.1">
            <p style="padding-left: 25pt; text-indent: -5pt; text-align: left">
              it will not hold itself out as a licensee for the System, the
              Intellectual Property or Know How;
            </p>
            <p style="text-indent: 0pt; text-align: left"><br /></p>
          </li>
          <li data-list-text="14.2">
            <p style="padding-left: 25pt; text-indent: -5pt; text-align: left">
              it will immediately cease utilising the System and return the
              same, along with all documentation and copies thereof to the
              Licensor;
            </p>
            <p style="text-indent: 0pt; text-align: left"><br /></p>
          </li>
          <li data-list-text="14.3">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 193%;
                text-align: justify;
              "
            >
              it will immediately cause all copies of the System and
              accompanying documentation held by its affiliates to be returned
              to the Licensor;
            </p>
            <p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="14.4">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 194%;
                text-align: justify;
              "
            >
              any and all Confidential Information in the Licensee’s possession
              shall forthwith, and within no longer than 30 (thirty) days of
              termination, be returned to the Licensor, including copies
              thereof, and the Licensee warrants that it shall not thereafter
              remain in possession of any Intellectual Property of the Licensor
              or pertaining to the System.
            </p>
            <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="14.5">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 196%;
                text-align: justify;
              "
            >
              It is specifically recorded and agreed that the obligations
              imposed upon the Licensee regarding the supply of Know How by the
              Licensor, Intellectual Property, Trademarks, Patents and Secrecy
              shall survive the termination of this Agreement.
            </p>
            <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="14.6">
            <p style="padding-left: 25pt; text-indent: -5pt; text-align: left">
              It is further specifically agreed that any data in the system
              belonging to the Licensee shall remain with the Licensee.
            </p>
            <p style="text-indent: 0pt; text-align: left"><br /></p>
          </li>
        </ol>
      </li>
      <li data-list-text="15.">
        <p class="text-h3" style="text-align: left">
          <a name="bookmark25">&zwnj;</a>LICENSEE NOT AGENT OR PARTNER OF
          LICENSOR
        </p>
        <p
          style="
            padding-top: 5pt;
            padding-left: 25pt;
            text-indent: -5pt;
            text-align: left;
          "
        >
          Nothing in this agreement shall be construed as -
        </p>
        <p style="text-indent: 0pt; text-align: left"><br /></p>
        <ol id="l31">
          <li data-list-text="15.1">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 193%;
                text-align: justify;
              "
            >
              constituting the Licensee as agent of the Licensor or granting any
              authority to the Licensee to represent the Licensor or to give any
              warranties or representations of whatsoever nature on behalf of
              the Licensor;
            </p>
            <p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="15.2">
            <p style="padding-left: 25pt; text-indent: -5pt; text-align: left">
              constituting a partnership between the Licensee and the Licensor.
            </p>
            <p style="text-indent: 0pt; text-align: left"><br /></p>
          </li>
        </ol>
      </li>
      <li data-list-text="16">
        <p class="text-h3" style="text-align: left">
          <a name="bookmark26">&zwnj;</a>REPRESENTATIONS, WARRANTIES AND
          COVENANTS
        </p>
        <ol id="l32">
          <li data-list-text="16.1">
            <p
              style="
                padding-top: 5pt;
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 194%;
                text-align: justify;
              "
            >
              Each Party represents and warrants that it has full right, power,
              and authority to enter into this Agreement and to perform i ts
              obligations and duties under this Agreement, and that the
              performance of such obligations and duties does not conflict with
              or result in a breach of any other agreements of such party or any
              judgment, order, or decree by which such party is bound.
            </p>
            <p style="padding-top: 8pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text="17">
        <p class="text-h3" style="text-align: left">
          <a name="bookmark27">&zwnj;</a>DOMICILIUM CITANDI ET EXECUTANDI
        </p>
        <ol id="l33">
          <li data-list-text="17.1">
            <p
              style="
                padding-top: 5pt;
                padding-left: 52pt;
                text-indent: -21pt;
                line-height: 193%;
                text-align: left;
              "
            >
              <a name="bookmark28">&zwnj;</a>The parties choose as their
              domicilia citandi et executandi for all purposes under this
              agreement, whether in respect of court process, notices or other
              documents or communications of whatsoever nature (including the
              exercise of any option), the following addresses:
            </p>
            <p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
            <ol id="l34">
              <li data-list-text="17.1.1">
                <p
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    text-align: left;
                  "
                >
                  the Licensor:
                </p>
                <p style="text-indent: 0pt; text-align: left">
                  <br />
                </p>
                <p
                  style="
                    padding-left: 60pt;
                    line-height: 169%;
                    text-align: left;
                  "
                >
                  Physical: 13 Caicos Isles 27 Silver Street Goedeburg Benoni
                </p>
                <p style="padding-top: 6pt; text-indent: 0pt; text-align: left">
                  <br />
                </p>
                <p
                  style="padding-left: 60pt; text-indent: 0pt; text-align: left"
                >
                  Postal: As above
                </p>
                <p style="padding-top: 6pt; text-indent: 0pt; text-align: left">
                  <br />
                </p>
                <p
                  style="padding-left: 60pt; text-indent: 0pt; text-align: left"
                >
                  <a
                    href="mailto:info@zeroeight.co.za"
                    class="s3"
                    target="_blank"
                    >E-mail: </a
                  ><a href="mailto:info@zeroeight.co.za" target="_blank"
                    >info@zeroeight.co.za</a
                  >
                </p>
                <p style="text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
              <li data-list-text="17.1.2">
                <p
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    text-align: left;
                  "
                >
                  The Licensee:
                </p>
                <p
                  style="
                    padding-top: 3pt;
                    padding-left: 65pt;
                    text-indent: -13pt;
                    text-align: left;
                  "
                >
                  As Per PayFast sign up information and Licensee Name on “The
                  System”.
                </p>
                <p style="text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
              <li data-list-text="17.1.3">
                <p
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    line-height: 193%;
                    text-align: left;
                  "
                >
                  Any notice or communication required or permitted to be given
                  in terms of this agreement shall be valid and effective only
                  if in writing, but it shall be competent to give notice by
                  telefax or e-mail.
                </p>
                <p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
            </ol>
          </li>
          <li data-list-text="17.2">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 194%;
                text-align: justify;
              "
            >
              Either party may by notice to the other party change the physical
              address chosen as its domicilium citandi et executandi to another
              physical address where postal delivery occurs in South Africa or
              its postal address or e-mail address, provided that the change
              shall become effective on the 10th (tenth) business day from the
              deemed receipt of the notice by the other party.
            </p>
            <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="17.3">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 194%;
                text-align: justify;
              "
            >
              Any notice to a party -sent by prepaid registered post (by airmail
              if appropriate) in a correctly addressed envelope to it at an
              address chosen as its domicilium citandi et executandi to which
              post is delivered shall be deemed to have been received on the
              10th (tenth) business day after posting (unless the contrary is
              proved);
            </p>
            <p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
            <ol id="l35">
              <ol id="l36">
                <ol id="l37">
                  <li data-list-text="17.3.3">
                    <p
                      style="
                        padding-left: 50pt;
                        text-indent: -13pt;
                        line-height: 193%;
                        text-align: left;
                      "
                    >
                      delivered by hand to a responsible person during ordinary
                      business hours at the physical address chosen as its
                      domicilium citandi et executandi shall be deemed to have
                      been received on the day of delivery; or
                    </p>
                    <p
                      style="
                        padding-top: 3pt;
                        text-indent: 0pt;
                        text-align: left;
                      "
                    >
                      <br />
                    </p>
                  </li>
                  <li data-list-text="17.3.4">
                    <p
                      style="
                        padding-left: 50pt;
                        text-indent: -13pt;
                        line-height: 193%;
                        text-align: left;
                      "
                    >
                      <a href="#bookmark28" class="s3"
                        >sent by e-mail to its chosen e-mail address stipulated
                        in clause </a
                      >17.1, shall be deemed to have been received on the date
                      of despatch (unless the contrary is proved).
                    </p>
                  </li>
                </ol>
              </ol>
            </ol>
            <p style="padding-top: 9pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
            <p
              class="s4"
              style="text-indent: 0pt; line-height: 111%; text-align: left"
            >
              <a name="bookmark29">&zwnj;</a>Notwithstanding anything to the
              contrary herein contained a written notice or communication
              actually received by a party shall be an adequate written notice
              or communication to it notwithstanding that it was not sent to or
              delivered at its chosen domicilium citandi et executandi.
            </p>
            <p style="padding-top: 8pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text="18">
        <p
          class="text-h3"
          style="padding-left: 51pt; text-indent: -46pt; text-align: left"
        >
          <a name="bookmark30">&zwnj;</a>GENERAL
        </p>
        <ol id="l38">
          <li data-list-text="18.1">
            <p
              style="
                padding-top: 5pt;
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 193%;
                text-align: justify;
              "
            >
              This agreement constitutes the whole agreement between the parties
              relating to the subject matter hereof and supersedes any other
              discussions, agreements and/or understandings regarding the
              subject matter hereof.
            </p>
            <p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="18.2">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 194%;
                text-align: justify;
              "
            >
              No amendment or consensual cancellation of this agreement or any
              provision or term hereof or of any agreement, bill of exchange or
              other document issued or executed pursuant to or in terms of this
              agreement and no settlement of any disputes arising under this
              agreement and no extension of time, waiver or relaxation or
              suspension of or agreement not to enforce or to suspend or
              postpone the enforcement of any of the provisions or terms of this
              agreement or of any agreement, bill of exchange or other document
              issued pursuant to or in terms of this agreement shall be binding
              unless recorded in a written document signed by the parties (or in
              the case of an extension of time, waiver or relaxation or
              suspension, signed by the party granting such extension, waiver or
              relaxation). Any such extension, waiver or relaxation or
              suspension which is so given or made shall be strictly construed
              as relating strictly to the matter in respect whereof it was made
              or given.
            </p>
            <p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="18.3">
            <p style="padding-left: 25pt; text-indent: -5pt; text-align: left">
              No oral pactum de non petendo shall be of any force or effect.
            </p>
            <p style="text-indent: 0pt; text-align: left"><br /></p>
          </li>
          <li data-list-text="18.4">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 195%;
                text-align: justify;
              "
            >
              No extension of time or waiver or relaxation of any of the
              provisions or terms of this agreement or any agreement, bill of
              exchange or other document issued or executed pursuant to or in
              terms of this agreement, shall operate as an estoppel against any
              party in respect of its rights under this agreement, nor shall it
              operate so as to preclude such party thereafter from exercising i
              ts rights strictly in accordance with this agreement.
            </p>
            <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="18.5">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 196%;
                text-align: justify;
              "
            >
              To the extent permissible by law no party shall be bound by any
              express or implied term, representation, warranty, promise or the
              like not recorded herein, whether it induced the contract and/or
              whether it was negligent or not.
            </p>
            <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="18.6">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 196%;
                text-align: justify;
              "
            >
              No part of this agreement shall constitute a stipulatio alteri in
              favour of any person who is not a party to this agreement unless
              the provision in question expressly provides that it does
              constitute a stipulatio alteri.
            </p>
          </li>
          <li data-list-text="18.7">
            <p
              style="
                padding-top: 3pt;
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 196%;
                text-align: justify;
              "
            >
              To the extent applicable this agreement and its implementation
              shall be subject to obtaining any necessary regulatory authority
              or approval required in order to lawfully implement this
              agreement.
            </p>
            <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="18.8">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 196%;
                text-align: justify;
              "
            >
              In the event that any of the terms of this Agreement are found to
              be invalid, unlawful or unenforceable, those terms will be
              severable from the remaining terms, which will continue to be
              valid and enforceable.
            </p>
            <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="18.9">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 196%;
                text-align: justify;
              "
            >
              Each of the Parties will bear its own cost incurred as a result of
              the negotiation, drafting and finalisation of this Agreement,
              which will include but not be limited to all legal fees.
            </p>
            <p style="padding-top: 8pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text="19">
        <p class="text-h3" style="text-align: left">
          <a name="bookmark31">&zwnj;</a>GOVERNING LAW
        </p>
        <p
          style="
            padding-top: 5pt;
            padding-left: 25pt;
            text-indent: 0pt;
            text-align: left;
          "
        >
          This agreement shall be construed in accordance with and governed by
          the laws of the Republic of South Africa.
        </p>
        <p style="text-indent: 0pt; text-align: left"><br /></p>
      </li>
      <li data-list-text="20">
        <p class="text-h3" style="text-align: left">
          <a name="bookmark32">&zwnj;</a>DISPUTE RESOLUTION
        </p>
        <ol id="l39">
          <ol id="l40">
            <li data-list-text="20.1.">
              <p
                style="
                  padding-top: 5pt;
                  padding-left: 25pt;
                  text-indent: -5pt;
                  line-height: 193%;
                  text-align: justify;
                "
              >
                The parties agree that if any dispute arises between them in
                relation to this Agreement, they will use their best endeavours
                to resolve that dispute in a spirit of good faith and on a
                commercially realistic basis by mutual negotiation.
              </p>
              <p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
                <br />
              </p>
            </li>
            <li data-list-text="20.2.">
              <p
                style="
                  padding-left: 25pt;
                  text-indent: -5pt;
                  line-height: 193%;
                  text-align: justify;
                "
              >
                If the parties fail to resolve any dispute, controversy or claim
                by way of mutual negotiation within 7 (seven) days or so
                attempting such dispute will be and is hereby referred to
                arbitration on demand by any of the parties.
              </p>
              <p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
                <br />
              </p>
            </li>
            <li data-list-text="20.3.">
              <p
                style="
                  padding-left: 25pt;
                  text-indent: -5pt;
                  line-height: 193%;
                  text-align: justify;
                "
              >
                The arbitration shall otherwise be conducted by a single
                arbitrator in terms of the rules of the Arbitration Foundation
                of South Africa, hereinafter referred to as AFSA.
              </p>
              <p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
                <br />
              </p>
            </li>
            <li data-list-text="20.4.">
              <p
                style="
                  padding-left: 25pt;
                  text-indent: -5pt;
                  line-height: 194%;
                  text-align: justify;
                "
              >
                The arbitrator shall be appointed within 7 (seven) days from the
                date on which the arbitration is first demanded, from the
                commercial panel of arbitrators of AFSA. The appointment shall
                be made by agreement between the parties, failing which the
                chairman of AFSA shall make the appointment.
              </p>
              <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
                <br />
              </p>
            </li>
            <li data-list-text="20.5.">
              <p
                style="
                  padding-left: 25pt;
                  text-indent: -5pt;
                  line-height: 196%;
                  text-align: justify;
                "
              >
                The arbitration shall be held at the offices of AFSA in Sandton
                and shall commence within 7 (seven) days from the date on which
                the arbitrator is appointed.
              </p>
              <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
                <br />
              </p>
            </li>
            <li data-list-text="20.6.">
              <p
                style="padding-left: 25pt; text-indent: -5pt; text-align: left"
              >
                The arbitrator’s award shall be final, and any party shall be
                entitled to have the award made an Order of Court.
              </p>
            </li>
          </ol>
        </ol>
        <p style="text-indent: 0pt; text-align: left"><br /></p>
      </li>
      <li data-list-text="21">
        <p class="text-h3" style="text-align: left">
          <a name="bookmark33">&zwnj;</a>FORCE MAJEURE
        </p>
        <ol id="l41">
          <li data-list-text="21.1">
            <p
              style="
                padding-top: 5pt;
                padding-left: 25pt;
                text-indent: -5pt;
                text-align: left;
              "
            >
              Neither of the Parties will be liable for a failure to perform any
              of its obligations if it proves:
            </p>
            <p style="text-indent: 0pt; text-align: left"><br /></p>
            <ol id="l42">
              <li data-list-text="21.1.1">
                <p
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    text-align: left;
                  "
                >
                  that the failure was due to an impediment beyond its control;
                </p>
                <p style="text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
              <li data-list-text="21.1.2">
                <p
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    line-height: 196%;
                    text-align: justify;
                  "
                >
                  that it could not reasonably be expected to have taken the
                  impediment and its effects upon the Party’s ability to perform
                  into account at the time of the conclusion of this Agreement;
                  and
                </p>
                <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
              <li data-list-text="21.1.3">
                <p
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    text-align: left;
                  "
                >
                  that it could not reasonably have avoided or overcome the
                  impediment or at least its effects.
                </p>
                <p style="text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
            </ol>
          </li>
          <li data-list-text="21.2">
            <p style="padding-left: 25pt; text-indent: -5pt; text-align: left">
              An impediment, includes but is not limited to:
            </p>
            <p style="text-indent: 0pt; text-align: left"><br /></p>
            <ol id="l43">
              <li data-list-text="21.2.1">
                <p
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    text-align: left;
                  "
                >
                  war, whether declared or not, civil war, civil violence, riots
                  and revolutions, acts of sabotage;
                </p>
                <p style="text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
              <li data-list-text="21.2.2">
                <p
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    text-align: left;
                  "
                >
                  natural disasters such as violent storms, cyclones,
                  earthquakes, tidal waves, floods, destruction by lightning;
                </p>
              </li>
              <li data-list-text="21.2.3">
                <p
                  style="
                    padding-top: 3pt;
                    padding-left: 50pt;
                    text-indent: -13pt;
                    text-align: left;
                  "
                >
                  explosions, fires, destruction of machines, of factories and
                  of any kind of installations;
                </p>
                <p style="text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
              <li data-list-text="21.2.4">
                <p
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    text-align: left;
                  "
                >
                  boycotts, strikes and lock-outs of all kinds, go-slows,
                  occupation of factories and premises and work stoppages;
                </p>
                <p style="text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
              <li data-list-text="21.2.5">
                <p
                  style="
                    padding-left: 50pt;
                    text-indent: -13pt;
                    line-height: 196%;
                    text-align: justify;
                  "
                >
                  acts of authority, whether lawful or unlawful, apart from acts
                  from which the party seeking relief has assumed the risk by
                  virtue of any other provisions of this Agreement.
                </p>
                <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
                  <br />
                </p>
              </li>
            </ol>
          </li>
          <li data-list-text="21.3">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 196%;
                text-align: justify;
              "
            >
              For the purposes of this clause “impediment” does not include lack
              of authorisations, of licences, of permits or of approvals
              necessary for the performance of this Agreement.
            </p>
            <p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
              <br />
            </p>
          </li>
          <li data-list-text="21.4">
            <p
              style="
                padding-left: 25pt;
                text-indent: -5pt;
                line-height: 194%;
                text-align: justify;
              "
            >
              Relief from liability for non-performance under this clause will
              start on the date which the party seeking relief gives Notice of
              the impediment and will stop on the date when the impediment
              ceases to exist; provided that if the impediment continues for a
              period of more than 60 days either of the Parties will be entitled
              to terminate this Agreement.
            </p>
          </li>
        </ol>
      </li>
    </ol>
    <p
      class="s1 text-h3"
      style="padding-top: 30pt; text-indent: 0pt; text-align: left"
    >
      SCHEDULE B – AD HOC FEES
    </p>
    <p style="padding-top: 7pt; text-indent: 0pt; text-align: left">
      <br />
    </p>
    <table
      style="border-collapse: collapse; margin-left: 10pt; margin-right: 10pt"
      cellspacing="0"
    >
      <tr style="height: 19pt">
        <td
          style="
            width: 82pt;
            border-top-style: solid;
            border-top-width: 1pt;
            border-left-style: solid;
            border-left-width: 1pt;
            border-bottom-style: solid;
            border-bottom-width: 1pt;
            border-right-style: solid;
            border-right-width: 1pt;
          "
        >
          <p
            class="s5"
            style="text-indent: 0pt; line-height: 9pt; text-align: center"
          >
            Activity
          </p>
        </td>
        <td
          style="
            width: 55pt;
            border-top-style: solid;
            border-top-width: 1pt;
            border-left-style: solid;
            border-left-width: 1pt;
            border-bottom-style: solid;
            border-bottom-width: 1pt;
            border-right-style: solid;
            border-right-width: 1pt;
          "
        >
          <p
            class="s5"
            style="text-indent: 0pt; line-height: 9pt; text-align: center"
          >
            Rate
          </p>
        </td>
        <td
          style="
            width: 55pt;
            border-top-style: solid;
            border-top-width: 1pt;
            border-left-style: solid;
            border-left-width: 1pt;
            border-bottom-style: solid;
            border-bottom-width: 1pt;
            border-right-style: solid;
            border-right-width: 1pt;
          "
        >
          <p
            class="s5"
            style="text-indent: 0pt; line-height: 9pt; text-align: center"
          >
            Number
          </p>
        </td>
        <td
          style="
            width: 61pt;
            border-top-style: solid;
            border-top-width: 1pt;
            border-left-style: solid;
            border-left-width: 1pt;
            border-bottom-style: solid;
            border-bottom-width: 1pt;
            border-right-style: solid;
            border-right-width: 1pt;
          "
        >
          <p
            class="s5"
            style="text-indent: 0pt; line-height: 9pt; text-align: center"
          >
            Frequency
          </p>
        </td>
        <td
          style="
            width: 77pt;
            border-top-style: solid;
            border-top-width: 1pt;
            border-left-style: solid;
            border-left-width: 1pt;
            border-bottom-style: solid;
            border-bottom-width: 1pt;
            border-right-style: solid;
            border-right-width: 1pt;
          "
        >
          <p
            class="s5"
            style="text-indent: 0pt; line-height: 9pt; text-align: center"
          >
            Notes
          </p>
        </td>
        <td
          style="
            width: 59pt;
            border-top-style: solid;
            border-top-width: 1pt;
            border-left-style: solid;
            border-left-width: 1pt;
            border-bottom-style: solid;
            border-bottom-width: 1pt;
            border-right-style: solid;
            border-right-width: 1pt;
          "
        >
          <p
            class="s5"
            style="text-indent: 0pt; line-height: 9pt; text-align: center"
          >
            Limits
          </p>
        </td>
        <td
          style="
            width: 82pt;
            border-top-style: solid;
            border-top-width: 1pt;
            border-left-style: solid;
            border-left-width: 1pt;
            border-bottom-style: solid;
            border-bottom-width: 1pt;
            border-right-style: solid;
            border-right-width: 1pt;
          "
        >
          <p
            class="s5"
            style="text-indent: 0pt; line-height: 9pt; text-align: center"
          >
            Activity
          </p>
        </td>
        <td
          style="
            width: 55pt;
            border-top-style: solid;
            border-top-width: 1pt;
            border-left-style: solid;
            border-left-width: 1pt;
            border-bottom-style: solid;
            border-bottom-width: 1pt;
            border-right-style: solid;
            border-right-width: 1pt;
          "
        >
          <p
            class="s5"
            style="text-indent: 0pt; line-height: 9pt; text-align: center"
          >
            Rate
          </p>
        </td>
      </tr>
      <tr style="height: 71pt">
        <td
          style="
            width: 82pt;
            border-top-style: solid;
            border-top-width: 1pt;
            border-left-style: solid;
            border-left-width: 1pt;
            border-bottom-style: solid;
            border-bottom-width: 1pt;
            border-right-style: solid;
            border-right-width: 1pt;
          "
        >
          <p style="text-indent: 0pt; text-align: left"><br /></p>
          <p class="s6" style="text-indent: 0pt; text-align: center">
            Training
          </p>
        </td>
        <td
          style="
            width: 55pt;
            border-top-style: solid;
            border-top-width: 1pt;
            border-left-style: solid;
            border-left-width: 1pt;
            border-bottom-style: solid;
            border-bottom-width: 1pt;
            border-right-style: solid;
            border-right-width: 1pt;
          "
        >
          <p style="text-indent: 0pt; text-align: left"><br /></p>
          <p class="s6" style="text-indent: 0pt; text-align: center">750.00</p>
        </td>
        <td
          style="
            width: 55pt;
            border-top-style: solid;
            border-top-width: 1pt;
            border-left-style: solid;
            border-left-width: 1pt;
            border-bottom-style: solid;
            border-bottom-width: 1pt;
            border-right-style: solid;
            border-right-width: 1pt;
          "
        >
          <p style="text-indent: 0pt; text-align: left"><br /></p>
          <p class="s6" style="text-indent: 0pt; text-align: center">
            per hour
          </p>
        </td>
        <td
          style="
            width: 61pt;
            border-top-style: solid;
            border-top-width: 1pt;
            border-left-style: solid;
            border-left-width: 1pt;
            border-bottom-style: solid;
            border-bottom-width: 1pt;
            border-right-style: solid;
            border-right-width: 1pt;
          "
        >
          <p style="text-indent: 0pt; text-align: left"><br /></p>
          <p class="s6" style="text-indent: 0pt; text-align: center">Hourly</p>
        </td>
        <td
          style="
            width: 77pt;
            border-top-style: solid;
            border-top-width: 1pt;
            border-left-style: solid;
            border-left-width: 1pt;
            border-bottom-style: solid;
            border-bottom-width: 1pt;
            border-right-style: solid;
            border-right-width: 1pt;
          "
        >
          <p style="text-indent: 0pt; text-align: left"><br /></p>
          <p
            class="s6"
            style="
              padding-left: 6pt;
              padding-right: 6pt;
              text-indent: 0pt;
              line-height: 112%;
              text-align: center;
            "
          >
            Training of internal employees in use of the system
          </p>
        </td>
        <td
          style="
            width: 59pt;
            border-top-style: solid;
            border-top-width: 1pt;
            border-left-style: solid;
            border-left-width: 1pt;
            border-bottom-style: solid;
            border-bottom-width: 1pt;
            border-right-style: solid;
            border-right-width: 1pt;
          "
        >
          <p style="text-indent: 0pt; text-align: left"><br /></p>
          <p class="s6" style="text-indent: 0pt; text-align: center">
            5 employees
          </p>
        </td>
        <td
          style="
            width: 82pt;
            border-top-style: solid;
            border-top-width: 1pt;
            border-left-style: solid;
            border-left-width: 1pt;
            border-bottom-style: solid;
            border-bottom-width: 1pt;
            border-right-style: solid;
            border-right-width: 1pt;
          "
        >
          <p style="text-indent: 0pt; text-align: left"><br /></p>
          <p class="s6" style="text-indent: 0pt; text-align: center">
            Training
          </p>
        </td>
        <td
          style="
            width: 55pt;
            border-top-style: solid;
            border-top-width: 1pt;
            border-left-style: solid;
            border-left-width: 1pt;
            border-bottom-style: solid;
            border-bottom-width: 1pt;
            border-right-style: solid;
            border-right-width: 1pt;
          "
        >
          <p style="text-indent: 0pt; text-align: left"><br /></p>
          <p class="s6" style="text-indent: 0pt; text-align: center">750.00</p>
        </td>
      </tr>
      <tr style="height: 43pt">
        <td
          style="
            width: 82pt;
            border-top-style: solid;
            border-top-width: 1pt;
            border-left-style: solid;
            border-left-width: 1pt;
            border-bottom-style: solid;
            border-bottom-width: 1pt;
            border-right-style: solid;
            border-right-width: 1pt;
          "
        >
          <p style="padding-top: 4pt; text-indent: 0pt; text-align: left">
            <br />
          </p>
          <p
            class="s6"
            style="
              padding-left: 8pt;
              text-indent: 15pt;
              line-height: 111%;
              text-align: left;
            "
          >
            Additional Employee Training
          </p>
        </td>
        <td
          style="
            width: 55pt;
            border-top-style: solid;
            border-top-width: 1pt;
            border-left-style: solid;
            border-left-width: 1pt;
            border-bottom-style: solid;
            border-bottom-width: 1pt;
            border-right-style: solid;
            border-right-width: 1pt;
          "
        >
          <p style="text-indent: 0pt; text-align: left"><br /></p>
          <p class="s6" style="text-indent: 0pt; text-align: center">150.00</p>
        </td>
        <td
          style="
            width: 55pt;
            border-top-style: solid;
            border-top-width: 1pt;
            border-left-style: solid;
            border-left-width: 1pt;
            border-bottom-style: solid;
            border-bottom-width: 1pt;
            border-right-style: solid;
            border-right-width: 1pt;
          "
        >
          <p
            class="s6"
            style="
              padding-top: 3pt;
              padding-left: 9pt;
              padding-right: 9pt;
              text-indent: 0pt;
              line-height: 111%;
              text-align: center;
            "
          >
            per employee per hour
          </p>
        </td>
        <td
          style="
            width: 61pt;
            border-top-style: solid;
            border-top-width: 1pt;
            border-left-style: solid;
            border-left-width: 1pt;
            border-bottom-style: solid;
            border-bottom-width: 1pt;
            border-right-style: solid;
            border-right-width: 1pt;
          "
        >
          <p style="padding-top: 4pt; text-indent: 0pt; text-align: left">
            <br />
          </p>
          <p
            class="s6"
            style="
              padding-left: 15pt;
              padding-right: 6pt;
              text-indent: -9pt;
              line-height: 111%;
              text-align: left;
            "
          >
            per employee per hour
          </p>
        </td>
        <td
          style="
            width: 77pt;
            border-top-style: solid;
            border-top-width: 1pt;
            border-left-style: solid;
            border-left-width: 1pt;
            border-bottom-style: solid;
            border-bottom-width: 1pt;
            border-right-style: solid;
            border-right-width: 1pt;
          "
        >
          <p
            class="s6"
            style="
              padding-top: 3pt;
              padding-left: 18pt;
              padding-right: 18pt;
              text-indent: 0pt;
              line-height: 111%;
              text-align: center;
            "
          >
            Additional employees training
          </p>
        </td>
        <td
          style="
            width: 59pt;
            border-top-style: solid;
            border-top-width: 1pt;
            border-left-style: solid;
            border-left-width: 1pt;
            border-bottom-style: solid;
            border-bottom-width: 1pt;
            border-right-style: solid;
            border-right-width: 1pt;
          "
        >
          <p style="text-indent: 0pt; text-align: left"><br /></p>
          <p class="s6" style="text-indent: 0pt; text-align: center">
            No limit
          </p>
        </td>
        <td
          style="
            width: 82pt;
            border-top-style: solid;
            border-top-width: 1pt;
            border-left-style: solid;
            border-left-width: 1pt;
            border-bottom-style: solid;
            border-bottom-width: 1pt;
            border-right-style: solid;
            border-right-width: 1pt;
          "
        >
          <p style="padding-top: 4pt; text-indent: 0pt; text-align: left">
            <br />
          </p>
          <p
            class="s6"
            style="
              padding-left: 7pt;
              text-indent: 15pt;
              line-height: 111%;
              text-align: left;
            "
          >
            Additional Employee Training
          </p>
        </td>
        <td
          style="
            width: 55pt;
            border-top-style: solid;
            border-top-width: 1pt;
            border-left-style: solid;
            border-left-width: 1pt;
            border-bottom-style: solid;
            border-bottom-width: 1pt;
            border-right-style: solid;
            border-right-width: 1pt;
          "
        >
          <p style="text-indent: 0pt; text-align: left"><br /></p>
          <p class="s6" style="text-indent: 0pt; text-align: center">150.00</p>
        </td>
      </tr>
      <tr style="height: 116pt">
        <td
          style="
            width: 82pt;
            border-top-style: solid;
            border-top-width: 1pt;
            border-left-style: solid;
            border-left-width: 1pt;
            border-bottom-style: solid;
            border-bottom-width: 1pt;
            border-right-style: solid;
            border-right-width: 1pt;
          "
        >
          <p style="text-indent: 0pt; text-align: left"><br /></p>
          <p class="s6" style="text-indent: 0pt; text-align: center">
            Consulting
          </p>
        </td>
        <td
          style="
            width: 55pt;
            border-top-style: solid;
            border-top-width: 1pt;
            border-left-style: solid;
            border-left-width: 1pt;
            border-bottom-style: solid;
            border-bottom-width: 1pt;
            border-right-style: solid;
            border-right-width: 1pt;
          "
        >
          <p style="text-indent: 0pt; text-align: left"><br /></p>
          <p class="s6" style="text-indent: 0pt; text-align: center">750.00</p>
        </td>
        <td
          style="
            width: 55pt;
            border-top-style: solid;
            border-top-width: 1pt;
            border-left-style: solid;
            border-left-width: 1pt;
            border-bottom-style: solid;
            border-bottom-width: 1pt;
            border-right-style: solid;
            border-right-width: 1pt;
          "
        >
          <p style="text-indent: 0pt; text-align: left"><br /></p>
          <p class="s6" style="text-indent: 0pt; text-align: center">
            per hour
          </p>
        </td>
        <td
          style="
            width: 61pt;
            border-top-style: solid;
            border-top-width: 1pt;
            border-left-style: solid;
            border-left-width: 1pt;
            border-bottom-style: solid;
            border-bottom-width: 1pt;
            border-right-style: solid;
            border-right-width: 1pt;
          "
        >
          <p style="text-indent: 0pt; text-align: left"><br /></p>
          <p class="s6" style="text-indent: 0pt; text-align: center">
            per hour
          </p>
        </td>
        <td
          style="
            width: 77pt;
            border-top-style: solid;
            border-top-width: 1pt;
            border-left-style: solid;
            border-left-width: 1pt;
            border-bottom-style: solid;
            border-bottom-width: 1pt;
            border-right-style: solid;
            border-right-width: 1pt;
          "
        >
          <p style="text-indent: 0pt; text-align: left"><br /></p>
          <p
            class="s6"
            style="
              padding-left: 6pt;
              padding-right: 5pt;
              text-indent: 0pt;
              line-height: 112%;
              text-align: center;
            "
          >
            Any activity regarding advice or investigation into correct
            documentation for Unit Standard Training or Licencing
          </p>
        </td>
        <td
          style="
            width: 59pt;
            border-top-style: solid;
            border-top-width: 1pt;
            border-left-style: solid;
            border-left-width: 1pt;
            border-bottom-style: solid;
            border-bottom-width: 1pt;
            border-right-style: solid;
            border-right-width: 1pt;
          "
        >
          <p style="text-indent: 0pt; text-align: left"><br /></p>
          <p class="s6" style="text-indent: 0pt; text-align: center">
            No Limit
          </p>
        </td>
        <td
          style="
            width: 82pt;
            border-top-style: solid;
            border-top-width: 1pt;
            border-left-style: solid;
            border-left-width: 1pt;
            border-bottom-style: solid;
            border-bottom-width: 1pt;
            border-right-style: solid;
            border-right-width: 1pt;
          "
        >
          <p style="text-indent: 0pt; text-align: left"><br /></p>
          <p class="s6" style="text-indent: 0pt; text-align: center">
            Consulting
          </p>
        </td>
        <td
          style="
            width: 55pt;
            border-top-style: solid;
            border-top-width: 1pt;
            border-left-style: solid;
            border-left-width: 1pt;
            border-bottom-style: solid;
            border-bottom-width: 1pt;
            border-right-style: solid;
            border-right-width: 1pt;
          "
        >
          <p style="text-indent: 0pt; text-align: left"><br /></p>
          <p class="s6" style="text-indent: 0pt; text-align: center">750.00</p>
        </td>
      </tr>
    </table>
    <p style="text-indent: 0pt; text-align: left"><br /></p>
    <p
      class="text-h3 font-weight-bold"
      style="text-indent: 0pt; text-align: left"
    >
      <a name="bookmark34">&zwnj;</a>SCHEDULE C – SYSTEM AND BANDWIDTH
      REQUIREMENTS
    </p>
    <p class="s7" style="padding-top: 5pt; text-indent: 0pt; text-align: left">
      <a name="bookmark35">&zwnj;</a>Recommended Operating Systems
    </p>
    <p style="padding-top: 6pt; text-indent: 0pt; text-align: left">
      <br />
    </p>
    <ul id="l44">
      <li data-list-text="">
        <p
          class="s8"
          style="padding-left: 50pt; text-indent: -18pt; text-align: left"
        >
          Windows: <span class="s7">7 or newer</span>
        </p>
        <p style="text-indent: 0pt; text-align: left"><br /></p>
        <p class="s7" style="text-indent: 0pt; text-align: left">
          <a name="bookmark36">&zwnj;</a>Hardware Requirements
        </p>
        <p
          class="s7"
          style="padding-top: 8pt; text-indent: 0pt; text-align: left"
        >
          We strongly recommend a computer fewer than 5 years old.
        </p>
        <p style="padding-top: 4pt; text-indent: 0pt; text-align: left">
          <br />
        </p>
      </li>
      <li data-list-text="">
        <p
          class="s7"
          style="padding-left: 50pt; text-indent: -18pt; text-align: left"
        >
          Processor: Minimum 1 GHz; Recommended 2GHz or more
        </p>
      </li>
      <li data-list-text="">
        <p
          class="s7"
          style="
            padding-top: 7pt;
            padding-left: 50pt;
            text-indent: -18pt;
            text-align: left;
          "
        >
          Ethernet connection (LAN) OR a wireless adapter (Wi-Fi)
        </p>
      </li>
      <li data-list-text="">
        <p
          class="s7"
          style="
            padding-top: 7pt;
            padding-left: 50pt;
            text-indent: -18pt;
            text-align: left;
          "
        >
          Minimum 20mbps download
        </p>
      </li>
      <li data-list-text="">
        <p
          class="s7"
          style="
            padding-top: 7pt;
            padding-left: 50pt;
            text-indent: -18pt;
            text-align: left;
          "
        >
          Hard Drive: Minimum 32 GB; Recommended 64 GB or more
        </p>
      </li>
      <li data-list-text="">
        <p
          class="s7"
          style="
            padding-top: 7pt;
            padding-left: 50pt;
            text-indent: -18pt;
            text-align: left;
          "
        >
          Memory (RAM): Minimum 1 GB; Recommended 4 GB or above
        </p>
      </li>
    </ul>
    <p style="text-indent: 0pt; text-align: left"><br /></p>
    <p style="text-indent: 0pt; text-align: left">
      <a name="bookmark37">&zwnj;</a>Supported Browsers
    </p>
    <p
      class="s7"
      style="
        padding-top: 8pt;

        text-indent: 0pt;
        text-align: left;
      "
    >
      People often ask what browser they should use. There is no single answer
      for this. Use whichever browser works best on your computer. However, we
      recommend downloading Google Chrome.
    </p>
    <p style="text-indent: 0pt; text-align: left"><br /></p>
    <p
      class="text-h3 font-weight-bold"
      style="text-indent: 0pt; text-align: left"
    >
      <a name="bookmark38">&zwnj;</a>SCHEDULE D – LICENSEE PROFILE ACCESS
    </p>
    <ul id="l45">
      <li data-list-text="">
        <p
          style="
            padding-top: 5pt;
            padding-left: 25pt;
            text-indent: -5pt;
            line-height: 110%;
            text-align: left;
          "
        >
          No employee of the Licensor may have access in any way to a Licensee
          profile. The Licensor does not have login details for the Licensee
          profile or their users.
        </p>
        <p style="text-indent: 0pt; text-align: left"><br /></p>
      </li>
      <li data-list-text="">
        <p
          style="
            padding-left: 25pt;
            text-indent: -5pt;
            line-height: 110%;
            text-align: left;
          "
        >
          The Licensor’s employees may not under any circumstances access a
          Licensee’s company profile. All login and administration functionality
          are available to the Licensee and only the Licensee’s approved users
          may access the Licensee profile.
        </p>
        <p style="text-indent: 0pt; text-align: left"><br /></p>
      </li>
      <li data-list-text="">
        <p
          style="
            padding-left: 25pt;
            text-indent: -5pt;
            line-height: 112%;
            text-align: left;
          "
        >
          Front-end support and training may only be conducted via a remote
          access tool such as AnyDesk, Team Viewer or similar and only where
          authorised to do so by the Licensee.
        </p>
      </li>
      <li data-list-text="">
        <p
          style="
            padding-top: 3pt;
            padding-left: 25pt;
            text-indent: -5pt;
            text-align: left;
          "
        >
          Front-end support and training may also be conducted on site with the
          Licensee and only where authorised to do so by the Licensee.
        </p>
        <p style="text-indent: 0pt; text-align: left"><br /></p>
      </li>
      <li data-list-text="">
        <p
          style="
            padding-left: 25pt;
            text-indent: -5pt;
            line-height: 111%;
            text-align: left;
          "
        >
          In circumstances where the Licensee is part of a group as, either a
          holding company, subsidiary or in any way affiliated to the Licensee,
          employees of the Licensor may not share any information pertaining to
          the access of the Licensee’s profile to any such affiliates.
          Authorisation for access needs to be made to the relevant
          administrator of the Licensee only.
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
import { Component, Vue, Watch } from "vue-property-decorator";

@Component
export default class Register extends Vue {}
</script>

<style type="css" scoped>
* {
  margin: 0;
  padding: 0;
  text-indent: 0;
}
.s1 {
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  /* font-size: 8pt; */
}
h1 {
  color: #0e4660;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  /* font-size: 8pt; */
}
.p,
p {
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
  margin: 0pt;
}
a {
  color: #00f;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: underline;
  /* font-size: 8pt; */
}
.s3 {
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
.s4 {
  color: #0e4660;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
.s5 {
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  /* font-size: 8pt; */
}
.s6 {
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
.s7 {
  color: #212121;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
.s8 {
  color: #212121;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: bold;
  text-decoration: none;
  /* font-size: 8pt; */
}
li {
  display: block;
}
#l1 {
  padding-left: 0pt;
  counter-reset: c1 1;
}
#l1 > li > *:first-child:before {
  counter-increment: c1;
  content: counter(c1, decimal) ". ";
  /* color: #0e4660; */
  text-decoration: none;
  /* font-size: 2rem; */
  font-weight: medium;
  line-height: 1;
  letter-spacing: -0.015625em;
}
#l1 > li:first-child > *:first-child:before {
  counter-increment: c1 0;
}
#l2 {
  padding-left: 0pt;
  counter-reset: c2 1;
}
#l2 > li > *:first-child:before {
  counter-increment: c2;
  content: counter(c1, decimal) "." counter(c2, decimal) ". ";
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /*  font-size: 8pt; */
}
#l2 > li:first-child > *:first-child:before {
  counter-increment: c2 0;
}
#l3 {
  padding-left: 0pt;
  counter-reset: c3 1;
}
#l3 > li > *:first-child:before {
  counter-increment: c3;
  content: counter(c1, decimal) "." counter(c2, decimal) "."
    counter(c3, decimal) ". ";
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
#l3 > li:first-child > *:first-child:before {
  counter-increment: c3 0;
}
#l4 {
  padding-left: 0pt;
  counter-reset: d1 2;
}
#l4 > li > *:first-child:before {
  counter-increment: d1;
  content: counter(d1, decimal) " ";
  color: black;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
}
#l4 > li:first-child > *:first-child:before {
  counter-increment: d1 0;
}
#l5 {
  padding-left: 0pt;
  counter-reset: d2 1;
}
#l5 > li > *:first-child:before {
  counter-increment: d2;
  content: counter(d1, decimal) "." counter(d2, decimal) " ";
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
#l5 > li:first-child > *:first-child:before {
  counter-increment: d2 0;
}
#l6 {
  padding-left: 0pt;
  counter-reset: c2 1;
}
#l6 > li > *:first-child:before {
  counter-increment: c2;
  content: counter(c1, decimal) "." counter(c2, decimal) ". ";
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
#l6 > li:first-child > *:first-child:before {
  counter-increment: c2 0;
}
#l7 {
  padding-left: 0pt;
  counter-reset: c2 1;
}
#l7 > li > *:first-child:before {
  counter-increment: c2;
  content: counter(c1, decimal) "." counter(c2, decimal) ". ";
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
#l7 > li:first-child > *:first-child:before {
  counter-increment: c2 0;
}
#l8 {
  padding-left: 0pt;
  counter-reset: c3 1;
}
#l8 > li > *:first-child:before {
  counter-increment: c3;
  content: counter(c1, decimal) "." counter(c2, decimal) "."
    counter(c3, decimal) ". ";
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
#l8 > li:first-child > *:first-child:before {
  counter-increment: c3 0;
}
#l9 {
  padding-left: 0pt;
  counter-reset: e1 5;
}
#l9 > li > *:first-child:before {
  counter-increment: e1;
  content: counter(e1, decimal) " ";
  color: black;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
}
#l9 > li:first-child > *:first-child:before {
  counter-increment: e1 0;
}
#l10 {
  padding-left: 0pt;
  counter-reset: e2 1;
}
#l10 > li > *:first-child:before {
  counter-increment: e2;
  content: counter(e1, decimal) "." counter(e2, decimal) " ";
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
#l10 > li:first-child > *:first-child:before {
  counter-increment: e2 0;
}
#l11 {
  padding-left: 0pt;
  counter-reset: e3 1;
}
#l11 > li > *:first-child:before {
  counter-increment: e3;
  content: counter(e1, decimal) "." counter(e2, decimal) "."
    counter(e3, decimal) " ";
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
#l11 > li:first-child > *:first-child:before {
  counter-increment: e3 0;
}
#l12 {
  padding-left: 0pt;
  counter-reset: e3 1;
}
#l12 > li > *:first-child:before {
  counter-increment: e3;
  content: counter(e1, decimal) "." counter(e2, decimal) "."
    counter(e3, decimal) " ";
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
#l12 > li:first-child > *:first-child:before {
  counter-increment: e3 0;
}
#l13 {
  padding-left: 0pt;
  counter-reset: c2 1;
}
#l13 > li > *:first-child:before {
  counter-increment: c2;
  content: counter(c1, decimal) "." counter(c2, decimal) ". ";
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
#l13 > li:first-child > *:first-child:before {
  counter-increment: c2 0;
}
#l14 {
  padding-left: 0pt;
  counter-reset: c2 1;
}
#l14 > li > *:first-child:before {
  counter-increment: c2;
  content: counter(c1, decimal) "." counter(c2, decimal) ". ";
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
#l14 > li:first-child > *:first-child:before {
  counter-increment: c2 0;
}
#l15 {
  padding-left: 0pt;
  counter-reset: c3 1;
}
#l15 > li > *:first-child:before {
  counter-increment: c3;
  content: counter(c1, decimal) "." counter(c2, decimal) "."
    counter(c3, decimal) ". ";
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
#l15 > li:first-child > *:first-child:before {
  counter-increment: c3 0;
}
#l16 {
  padding-left: 0pt;
  counter-reset: c3 1;
}
#l16 > li > *:first-child:before {
  counter-increment: c3;
  content: counter(c1, decimal) "." counter(c2, decimal) "."
    counter(c3, decimal) ". ";
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
#l16 > li:first-child > *:first-child:before {
  counter-increment: c3 0;
}
#l17 {
  padding-left: 0pt;
  counter-reset: c3 1;
}
#l17 > li > *:first-child:before {
  counter-increment: c3;
  content: counter(c1, decimal) "." counter(c2, decimal) "."
    counter(c3, decimal) ". ";
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
#l17 > li:first-child > *:first-child:before {
  counter-increment: c3 0;
}
#l18 {
  padding-left: 0pt;
  counter-reset: c2 1;
}
#l18 > li > *:first-child:before {
  counter-increment: c2;
  content: counter(c1, decimal) "." counter(c2, decimal) ". ";
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
#l18 > li:first-child > *:first-child:before {
  counter-increment: c2 0;
}
#l19 {
  padding-left: 0pt;
  counter-reset: c2 1;
}
#l19 > li > *:first-child:before {
  counter-increment: c2;
  content: counter(c1, decimal) "." counter(c2, decimal) ". ";
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
#l19 > li:first-child > *:first-child:before {
  counter-increment: c2 0;
}
li {
  display: block;
}
#l20 {
  padding-left: 0pt;
  counter-reset: f1 10;
}
#l20 > li > *:first-child:before {
  counter-increment: f1;
  content: counter(f1, decimal) " ";
  color: black;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
}
#l20 > li:first-child > *:first-child:before {
  counter-increment: f1 0;
}
#l21 {
  padding-left: 0pt;
  counter-reset: f2 4;
}
#l21 > li > *:first-child:before {
  counter-increment: f2;
  content: counter(f1, decimal) "." counter(f2, decimal) " ";
  color: black;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
}
#l21 > li:first-child > *:first-child:before {
  counter-increment: f2 0;
}
li {
  display: block;
}
#l22 {
  padding-left: 0pt;
  counter-reset: g1 11;
}
#l22 > li > *:first-child:before {
  counter-increment: g1;
  content: counter(g1, decimal) " ";
  color: black;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
}
#l22 > li:first-child > *:first-child:before {
  counter-increment: g1 0;
}
#l23 {
  padding-left: 0pt;
  counter-reset: g2 1;
}
#l23 > li > *:first-child:before {
  counter-increment: g2;
  content: counter(g1, decimal) "." counter(g2, decimal) " ";
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
#l23 > li:first-child > *:first-child:before {
  counter-increment: g2 0;
}
li {
  display: block;
}
#l24 {
  padding-left: 0pt;
  counter-reset: h1 12;
}
#l24 > li > *:first-child:before {
  counter-increment: h1;
  content: counter(h1, decimal) ". ";
  color: black;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
}
#l24 > li:first-child > *:first-child:before {
  counter-increment: h1 0;
}
#l25 {
  padding-left: 0pt;
  counter-reset: h2 1;
}
#l25 > li > *:first-child:before {
  counter-increment: h2;
  content: counter(h1, decimal) "." counter(h2, decimal) " ";
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
#l25 > li:first-child > *:first-child:before {
  counter-increment: h2 0;
}
#l26 {
  padding-left: 0pt;
  counter-reset: h3 1;
}
#l26 > li > *:first-child:before {
  counter-increment: h3;
  content: counter(h1, decimal) "." counter(h2, decimal) "."
    counter(h3, decimal) " ";
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
#l26 > li:first-child > *:first-child:before {
  counter-increment: h3 0;
}
#l27 {
  padding-left: 0pt;
  counter-reset: i1 12;
}
#l27 > li > *:first-child:before {
  counter-increment: i1;
  content: counter(i1, decimal) " ";
  color: black;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
}
#l27 > li:first-child > *:first-child:before {
  counter-increment: i1 0;
}
#l28 {
  padding-left: 0pt;
  counter-reset: i2 5;
}
#l28 > li > *:first-child:before {
  counter-increment: i2;
  content: counter(i1, decimal) "." counter(i2, decimal) " ";
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
#l28 > li:first-child > *:first-child:before {
  counter-increment: i2 0;
}
#l29 {
  padding-left: 0pt;
  counter-reset: h2 1;
}
#l29 > li > *:first-child:before {
  counter-increment: h2;
  content: counter(h1, decimal) "." counter(h2, decimal) " ";
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
#l29 > li:first-child > *:first-child:before {
  counter-increment: h2 0;
}
#l30 {
  padding-left: 0pt;
  counter-reset: h2 1;
}
#l30 > li > *:first-child:before {
  counter-increment: h2;
  content: counter(h1, decimal) "." counter(h2, decimal) " ";
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
#l30 > li:first-child > *:first-child:before {
  counter-increment: h2 0;
}
#l31 {
  padding-left: 0pt;
  counter-reset: h2 1;
}
#l31 > li > *:first-child:before {
  counter-increment: h2;
  content: counter(h1, decimal) "." counter(h2, decimal) " ";
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
#l31 > li:first-child > *:first-child:before {
  counter-increment: h2 0;
}
#l32 {
  padding-left: 0pt;
  counter-reset: h2 1;
}
#l32 > li > *:first-child:before {
  counter-increment: h2;
  content: counter(h1, decimal) "." counter(h2, decimal) " ";
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
#l32 > li:first-child > *:first-child:before {
  counter-increment: h2 0;
}
#l33 {
  padding-left: 0pt;
  counter-reset: h2 1;
}
#l33 > li > *:first-child:before {
  counter-increment: h2;
  content: counter(h1, decimal) "." counter(h2, decimal) " ";
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
#l33 > li:first-child > *:first-child:before {
  counter-increment: h2 0;
}
#l34 {
  padding-left: 0pt;
  counter-reset: h3 1;
}
#l34 > li > *:first-child:before {
  counter-increment: h3;
  content: counter(h1, decimal) "." counter(h2, decimal) "."
    counter(h3, decimal) " ";
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
#l34 > li:first-child > *:first-child:before {
  counter-increment: h3 0;
}
#l35 {
  padding-left: 0pt;
  counter-reset: j1 17;
}
#l35 > li > *:first-child:before {
  counter-increment: j1;
  content: counter(j1, decimal) " ";
  color: black;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
}
#l35 > li:first-child > *:first-child:before {
  counter-increment: j1 0;
}
#l36 {
  padding-left: 0pt;
  counter-reset: j2 3;
}
#l36 > li > *:first-child:before {
  counter-increment: j2;
  content: counter(j1, decimal) "." counter(j2, decimal) " ";
  color: black;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
}
#l36 > li:first-child > *:first-child:before {
  counter-increment: j2 0;
}
#l37 {
  padding-left: 0pt;
  counter-reset: j3 3;
}
#l37 > li > *:first-child:before {
  counter-increment: j3;
  content: counter(j1, decimal) "." counter(j2, decimal) "."
    counter(j3, decimal) " ";
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
#l37 > li:first-child > *:first-child:before {
  counter-increment: j3 0;
}
#l38 {
  padding-left: 0pt;
  counter-reset: h2 1;
}
#l38 > li > *:first-child:before {
  counter-increment: h2;
  content: counter(h1, decimal) "." counter(h2, decimal) " ";
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
#l38 > li:first-child > *:first-child:before {
  counter-increment: h2 0;
}
#l39 {
  padding-left: 0pt;
  counter-reset: k1 20;
}
#l39 > li > *:first-child:before {
  counter-increment: k1;
  content: counter(k1, decimal) " ";
  color: black;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
}
#l39 > li:first-child > *:first-child:before {
  counter-increment: k1 0;
}
#l40 {
  padding-left: 0pt;
  counter-reset: k2 1;
}
#l40 > li > *:first-child:before {
  counter-increment: k2;
  content: counter(k1, decimal) "." counter(k2, decimal) ". ";
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
#l40 > li:first-child > *:first-child:before {
  counter-increment: k2 0;
}
#l41 {
  padding-left: 0pt;
  counter-reset: h2 1;
}
#l41 > li > *:first-child:before {
  counter-increment: h2;
  content: counter(h1, decimal) "." counter(h2, decimal) " ";
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
#l41 > li:first-child > *:first-child:before {
  counter-increment: h2 0;
}
#l42 {
  padding-left: 0pt;
  counter-reset: h3 1;
}
#l42 > li > *:first-child:before {
  counter-increment: h3;
  content: counter(h1, decimal) "." counter(h2, decimal) "."
    counter(h3, decimal) " ";
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
#l42 > li:first-child > *:first-child:before {
  counter-increment: h3 0;
}
#l43 {
  padding-left: 0pt;
  counter-reset: h3 1;
}
#l43 > li > *:first-child:before {
  counter-increment: h3;
  content: counter(h1, decimal) "." counter(h2, decimal) "."
    counter(h3, decimal) " ";
  color: black;
  font-family: Arial, sans-serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
#l43 > li:first-child > *:first-child:before {
  counter-increment: h3 0;
}
li {
  display: block;
}
#l44 {
  padding-left: 0pt;
}
#l44 > li > *:first-child:before {
  content: "-";
  color: #212121;
  font-family: Symbol, serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 10pt; */
}
li {
  display: block;
}
#l45 {
  padding-left: 0pt;
}
#l45 > li > *:first-child:before {
  content: "-";
  color: black;
  font-family: Symbol, serif;
  font-style: normal;
  font-weight: normal;
  text-decoration: none;
  /* font-size: 8pt; */
}
table,
tbody {
  vertical-align: top;
  overflow: visible;
}
</style>
